'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import type { BlogTag } from '@/content/blog'

/**
 * Sends `/blog?tag=Terugkerend%20werk` to `/blog/tag/terugkerend-werk`.
 *
 * The tag filter used to live in the query string. Those URLs were shareable, so some of them are
 * shared, and a reader following one should land on the subject rather than on the full index.
 *
 * It has to happen here rather than in `next.config.ts`: a config redirect can match on a query
 * parameter but cannot slugify its value, and the parameter holds the tag as the author wrote it —
 * spaces, capitals and all. The map from that to a slug is data, not a pattern.
 *
 * `replace`, not `push`, so the browser's back button returns to wherever the reader came from
 * instead of to a URL that immediately redirects again. An unknown tag falls through to the index,
 * which is where the visitor already is.
 */
export function BlogLegacyTagRedirect({ basePath, tags }: { basePath: string; tags: BlogTag[] }) {
  const router = useRouter()
  const requested = useSearchParams().get('tag')

  useEffect(() => {
    if (!requested) return
    const match = tags.find((entry) => entry.tag === requested)
    router.replace(match ? `${basePath}/tag/${match.slug}` : basePath)
  }, [requested, tags, basePath, router])

  return null
}
